export default __webpack_public_path__ + "static/media/3.5aa61aab.jpeg";